"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Gridline = exports.AXIS_ORIENTATIONS = void 0;
/* eslint-disable react/forbid-prop-types */
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importDefault(require("react"));
const colors_1 = require("../../utilities/colors");
exports.AXIS_ORIENTATIONS = lodash_1.default.keyBy(['horizontal', 'vertical']);
function Gridlines(_ref) {
  let {
    gridColor,
    onClick = () => {},
    onMouseOut = () => {},
    onMouseOver = () => {},
    orientation,
    range,
    strokeWidth = 1,
    ticks
  } = _ref;
  const isHorizontal = orientation === exports.AXIS_ORIENTATIONS.horizontal;
  const [len1, len2] = range;
  const modGridColor = (0, colors_1.parseColor)(gridColor, colors_1.AXIS_LINE_COLOR);
  const transitionedTicks = ticks.map((tick, i) => {
    const sw = tick.strokeWidth || strokeWidth;
    let strokeDasharray = '0 0';
    if (tick.strokeStyle === 'dot') {
      strokeDasharray = `1 ${sw * 2}`;
    } else if (tick.strokeStyle === 'dash') {
      strokeDasharray = `${sw * 2} ${sw * 2}`;
    }
    return {
      key: i,
      ...(isHorizontal ? {
        x1: len1,
        x2: len2,
        y1: tick.point,
        y2: tick.point
      } : {
        x1: tick.point,
        x2: tick.point,
        y1: len1,
        y2: len2
      }),
      gridColor: (0, colors_1.parseColor)(tick.gridColor, modGridColor),
      strokeCap: tick.strokeCap,
      strokeDasharray,
      strokeWidth: sw,
      opacity: 1
    };
  });
  return react_1.default.createElement("g", {
    className: `gridlines ${orientation}-gridlines`
  }, transitionedTicks.map(item => {
    const {
      gridColor,
      strokeCap,
      strokeWidth,
      strokeDasharray,
      x1,
      x2,
      y1,
      y2,
      opacity
    } = item;
    return react_1.default.createElement(Gridline, {
      key: item.key,
      gridColor: gridColor,
      strokeCap: strokeCap,
      strokeDasharray: strokeDasharray,
      strokeWidth: strokeWidth,
      x1: x1,
      x2: x2,
      y1: y1,
      y2: y2,
      opacity: opacity,
      onMouseOver: event => onMouseOver(event, item),
      onMouseOut: event => onMouseOut(event, item),
      onClick: event => onClick(event, item)
    });
  }));
}
Gridlines.propTypes = {
  /**
   * Gridline color
   */
  gridColor: prop_types_1.string,
  /**
   * function to activate on click
   * parameters: (event, item)
   */
  onClick: prop_types_1.func,
  /**
   * function to activate on mouseOver
   * parameters: (event, item)
   */
  onMouseOver: prop_types_1.func,
  /**
   * function to activate on mouseOut
   * parameters: (event, item)
   */
  onMouseOut: prop_types_1.func,
  /**
   * Places gridlines horizontally or vertically.
   */
  orientation: (0, prop_types_1.oneOf)(lodash_1.default.values(exports.AXIS_ORIENTATIONS)).isRequired,
  /**
   * End positions of gridlines on the same axis as orientation.
   */
  range: (props, propName, componentName) => {
    if (props[propName].length !== 2) {
      return new Error(`Invalid array length ${props[propName].length} (expected 2) for prop ${propName} supplied to ${componentName}. Validation failed.`);
    }
    return null;
  },
  /**
   * Gridline stroke width.
   */
  strokeWidth: prop_types_1.number,
  /**
   * Custom gridline positions.
   */
  ticks: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    gridColor: prop_types_1.string,
    point: prop_types_1.number.isRequired,
    strokeCap: (0, prop_types_1.oneOf)(['butt', 'round', 'square']),
    strokeStyle: (0, prop_types_1.oneOf)(['solid', 'dot', 'dash']),
    strokeWidth: prop_types_1.number
  })).isRequired
};
exports.default = Gridlines;
function Gridline(_ref2) {
  let {
    gridColor,
    opacity = 1,
    strokeCap,
    strokeDasharray,
    strokeWidth = 1,
    x1,
    x2,
    y1,
    y2
  } = _ref2;
  return react_1.default.createElement("line", {
    x1: x1,
    y1: y1,
    x2: x2,
    y2: y2,
    className: "gridline",
    stroke: gridColor,
    strokeLinecap: strokeCap,
    strokeDasharray: strokeDasharray,
    strokeWidth: strokeWidth,
    opacity: opacity
  });
}
exports.Gridline = Gridline;
Gridline.propTypes = {
  gridColor: prop_types_1.string,
  opacity: prop_types_1.number,
  strokeCap: prop_types_1.string,
  strokeDasharray: prop_types_1.string,
  strokeWidth: prop_types_1.number,
  x1: prop_types_1.number,
  x2: prop_types_1.number,
  y1: prop_types_1.number,
  y2: prop_types_1.number
};